import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { SessionService } from 'src/utilities/session/session.service';
import { PermissionsConfig } from 'src/utilities/permissions/permissions';

/**
 * Guard de permisos por ruta.
 * Lee `data.module` y opcionalmente `data.permission` de la configuración de la ruta.
 * - Si solo hay `module` → comprueba que el usuario tenga algún permiso en ese módulo (hasModulePermission).
 * - Si hay `module` + `permission` → comprueba el permiso específico (HasRolePermission).
 * - Si no hay `data.module` → permite el acceso (sin restricción de permisos).
 *
 * IMPORTANTE: Debe ir DESPUÉS de LoggedInGuard en canActivate para que los permisos ya estén cargados.
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const module = route.data?.['module'];

    // Si la ruta no define módulo, no hay restricción de permisos
    if (module === undefined || module === null) {
      return true;
    }

    const permission = route.data?.['permission'];
    const permissions = new PermissionsConfig(module);

    let hasAccess = false;

    if (permission !== undefined && permission !== null) {
      // Comprobar permiso específico dentro del módulo
      hasAccess = permissions.HasRolePermission(this.sessionService, permission);
    } else {
      // Comprobar que tenga cualquier permiso en el módulo
      hasAccess = permissions.hasModulePermission(this.sessionService, module);
    }

    if (!hasAccess) {
      console.warn(`PermissionGuard: acceso denegado a '${route.routeConfig?.path}' — módulo: ${module}, permiso: ${permission ?? 'cualquiera'}`);
      void this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
